//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { intlMixin } from '@/i18n/intl-i18n';
import { resolveCourseCover, normalizeCategory } from "./courseCover";

// 封面图标映射 — 对齐原型 T.covers
var COVER_ICONS = {
  smart: '⚙',
  digital: '▦',
  service: '✦',
  transport: '◈',
  business: '◇',
  culture: '◎',
  zhinengzhizao: '⚙',
  shuzijishu: '▦',
  xiandaifuwu: '✦',
  jiaotongyunshu: '◈',
  caijingshangmao: '◇',
  wenhuayishu: '◎'
};
export default {
  name: 'CourseCard',
  mixins: [intlMixin],
  props: {
    course: {
      type: Object,
      required: true
    }
  },
  computed: {
    coverCategory: function coverCategory() {
      return normalizeCategory(this.course.category);
    },
    coverImage: function coverImage() {
      return resolveCourseCover(this.course);
    },
    coverIcon: function coverIcon() {
      return COVER_ICONS[this.coverCategory] || '◆';
    },
    langLabel: function langLabel() {
      return this.$intlLangLabel(this.course.selectedLanguage || this.$intlLang);
    },
    courseTitle: function courseTitle() {
      return this.course.title;
    }
  }
};